import { render, staticRenderFns } from "./ImageThumbnail.vue?vue&type=template&id=1b9176ff&scoped=true"
import script from "./ImageThumbnail.vue?vue&type=script&lang=ts"
export * from "./ImageThumbnail.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./ImageThumbnail.vue?vue&type=style&index=0&id=1b9176ff&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1b9176ff",
  null
  ,true
)

export default component.exports